var _style, _defs, _path, _path2, _g, _g2, _g3, _defs2, _path3, _path4, _path5, _defs3, _path6, _path7, _g4, _g5, _g6, _defs4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st1 {\n\t\t\tclip-path: url(#SVGID_00000169557595257646706770000008255815345721379994_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st2 {\n\t\t\tfill: #2B286C;\n\t\t}\n\n\t\t.st3 {\n\t\t\tfill: #2C2A70;\n\t\t}\n\n\t\t.st4 {\n\t\t\tfill: #292768;\n\t\t}\n\n\t\t.st5 {\n\t\t\tfill: #3A3692;\n\t\t}\n\n\t\t.st6 {\n\t\t\tclip-path: url(#SVGID_00000055676220813813332870000011975129715471596709_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st7 {\n\t\t\tfill: #363389;\n\t\t}\n\n\t\t.st8 {\n\t\t\tfill: #343184;\n\t\t}\n\n\t\t.st9 {\n\t\t\tfill: #333080;\n\t\t}\n\n\t\t.st10 {\n\t\t\tclip-path: url(#SVGID_00000156546836731352243630000005572676918309969585_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st11 {\n\t\t\tfill: #2A276A;\n\t\t}\n\n\t\t.st12 {\n\t\t\tclip-path: url(#SVGID_00000130631698244988184040000008703951538588188086_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st13 {\n\t\t\tfill: #2E2B74;\n\t\t}\n\n\t\t.st14 {\n\t\t\tfill: #302D78;\n\t\t}\n\n\t\t.st15 {\n\t\t\tfill: #312E7C;\n\t\t}\n\n\t\t.st16 {\n\t\t\tfill: #4843B5;\n\t\t}\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Unplanned_Vehicle",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M741.39,826.17l-113.97-62c-31.86-17.33-42.31-61.17-23.17-99.47l113.97,62 C699.08,765,709.52,808.83,741.39,826.17z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034078666380240481560000009310406060774025871_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034078666380240481560000009310406060774025871_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M741.39,826.17l-113.97-62c-29.22-15.89-40.42-54.07-27.33-89.83l113.97,62 C700.96,772.1,712.17,810.27,741.39,826.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M714.05,736.34l-113.97-62c1.19-3.24,2.57-6.46,4.16-9.64l113.97,62 C716.63,729.88,715.24,733.1,714.05,736.34"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "835.39,595.64 721.42,533.65 668.53,426.49 782.5,488.49  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "708.9,613.42 594.94,551.42 721.42,533.65 835.39,595.64  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "709.19,460.59 595.22,398.6 701.42,383.67 815.39,445.67  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000025432684732586848520000006303531555819657131_",
    className: "st0",
    d: "M578.9,292.22l113.97,62 c-5.45-2.97-11.92-4.23-18.85-3.27l-113.97-62C566.98,287.99,573.45,289.25,578.9,292.22z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030449393894014318370000017516886118105243837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025432684732586848520000006303531555819657131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030449393894014318370000017516886118105243837_)",
      enableBackground: "new"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M674.01,350.94l-113.97-62c4.28-0.59,8.37-0.33,12.16,0.64l113.97,62 C682.38,350.6,678.29,350.35,674.01,350.94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M686.17,351.58l-113.97-62c1.96,0.5,3.83,1.2,5.61,2.07l113.97,62 C690.01,352.78,688.13,352.08,686.17,351.58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M691.78,353.65l-113.97-62c0.36,0.18,0.73,0.37,1.08,0.56l113.97,62 C692.51,354.02,692.15,353.83,691.78,353.65"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080916438170404037520000005751474300700406927_",
    className: "st0",
    d: "M422.8,870.95l-113.97-62 c-31.86-17.33-42.31-61.17-23.17-99.47l113.97,62C380.5,809.78,390.94,853.61,422.8,870.95z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091726796521464729140000004717207334909917860_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080916438170404037520000005751474300700406927_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091726796521464729140000004717207334909917860_)",
      enableBackground: "new"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.8,870.95l-113.97-62c-29.22-15.89-40.42-54.07-27.33-89.83l113.97,62 C382.38,816.88,393.59,855.05,422.8,870.95"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.47,781.11l-113.97-62c1.19-3.24,2.57-6.46,4.16-9.64l113.97,62 C398.04,774.65,396.66,777.87,395.47,781.11"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "354.7,777.79 240.74,715.79 205.42,682.57 319.38,744.56  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "355.41,395.71 241.45,333.72 560.04,288.94 674.01,350.94  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "319.38,744.56 205.42,682.57 205.98,376.9 319.95,438.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099657099737666005780000006990907458634514318_",
    className: "st0",
    d: "M319.95,438.9l-113.97-62 c0.1-21.09,15.94-40.38,35.46-43.18l113.97,62C335.89,398.52,320.05,417.81,319.95,438.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006676982158066406650000016810684790078519982_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099657099737666005780000006990907458634514318_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006676982158066406650000016810684790078519982_)",
      enableBackground: "new"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.95,438.9l-113.97-62c0.02-5.17,0.99-10.24,2.73-14.98l113.97,62 C320.94,428.66,319.97,433.72,319.95,438.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.68,423.92l-113.97-62c0.76-2.06,1.66-4.06,2.69-5.98l113.97,62 C324.34,419.86,323.44,421.86,322.68,423.92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M325.38,417.94l-113.97-62c0.87-1.62,1.84-3.19,2.89-4.69l113.97,62 C327.22,414.75,326.25,416.32,325.38,417.94"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M328.27,413.25l-113.97-62c0.99-1.41,2.06-2.77,3.19-4.05l113.97,62 C330.33,410.48,329.26,411.84,328.27,413.25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M331.46,409.2l-113.97-62c1.14-1.29,2.35-2.51,3.62-3.66l113.97,62 C333.81,406.68,332.6,407.91,331.46,409.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M335.08,405.54l-113.97-62c1.36-1.23,2.8-2.36,4.29-3.4l113.97,62 C337.88,403.18,336.45,404.31,335.08,405.54"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M339.37,402.14l-113.97-62c1.84-1.27,3.76-2.38,5.77-3.33l113.97,62 C343.14,399.76,341.21,400.88,339.37,402.14"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.14,398.82l-113.97-62c3.25-1.53,6.7-2.59,10.27-3.1l113.97,62 C351.84,396.23,348.39,397.29,345.14,398.82"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M885.9,588.54l-0.18,114.61l-44.9,6.31c12.62,21.87,12.57,51.03-0.14,76.47 c-13.17,26.34-36.98,43.38-61.44,46.82c-12.02,1.69-24.2,0.09-35.34-5.3c-33.82-16.35-45.32-61.47-25.69-100.76l-195.98,27.54 c12.62,21.87,12.57,51.03-0.14,76.47c-13.16,26.34-36.97,43.38-61.43,46.82c-12.02,1.69-24.2,0.09-35.34-5.29 c-33.81-16.36-45.31-61.47-25.68-100.76l-44.93,6.31l-35.32-33.22l0.57-305.67c0.1-21.09,15.94-40.38,35.46-43.18l318.6-44.78 c19.52-2.68,35.3,12.16,35.32,33.23l-0.14,76.42l106.2-14.93L885.9,588.54z M708.9,613.42l126.48-17.78L782.5,488.49 l-73.38,10.31L708.9,613.42"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.1780e1505978f84ce6fe3d9b0a790ba3.svg";
export { ForwardRef as ReactComponent };